import { z } from "zod";
import { matrixDefinitionBody } from "./report-matrix.js";

export const pinReportBody = z.object({
  reportDefinitionId: z.uuid(),
  name: z.string().trim().min(1).max(160),
  definition: matrixDefinitionBody,
  presentation: z.enum(["table", "chart"]),
  idempotencyKey: z.string().min(8).max(200),
}).strict();
export const reorderReportPinsBody = z.object({ ids: z.array(z.uuid()).max(24) }).strict();
export interface ReportDashboardPin {
  id: string;
  reportDefinitionId: string | null;
  name: string;
  definition: z.infer<typeof matrixDefinitionBody>;
  presentation: "table" | "chart";
  available: boolean;
}
export interface ReportDashboardResponse { pins: ReportDashboardPin[] }
